"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["as", "className", "baseClass", "baseClassActive", "children", "style", "onClick"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/Fade/index.js";
var defaultProps = {
  as: "div",
  baseClass: "fade",
  timeout: 150,
  appear: true,
  baseClassActive: "show"
};
function Fade(_ref) {
  var _this = this;
  var Comp = _ref.as,
    className = _ref.className,
    baseClass = _ref.baseClass,
    baseClassActive = _ref.baseClassActive,
    children = _ref.children,
    style = _ref.style,
    onClick = _ref.onClick,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, Object.assign({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }), function (status) {
    var isActive = status === "entered";
    var classes = (0, _classNames["default"])(className, baseClass, isActive && baseClassActive);
    return /*#__PURE__*/_react["default"].createElement(Comp, {
      className: classes,
      style: style,
      onClick: onClick,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 21
      }
    }, children);
  });
}
Fade.defaultProps = defaultProps;
var _default = exports["default"] = Fade;